import React from 'react';

interface DrawerContentProps {
    children: React.ReactNode;
    className?: string;
}

export const DrawerContent = ({
    children,
    className = '',
}: DrawerContentProps) => {
    return (
        <div className={`drawer-content-wrapper ${className}`}>{children}</div>
    );
};
